import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
// Archivo for titles — self-hosted (bundled) so headings render offline too.
import '@fontsource/archivo/400.css';
import '@fontsource/archivo/500.css';
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import { beginBootTrace, markBoot } from './utils/bootTrace';
import { startAppUpdates } from './features/pwa/appUpdate';
import { startNativeApp } from './lib/nativeApp';
import { installQuickSearchShortcut } from './components/quickSearchShortcut';
import { clearGridSessionFiltersOnReload } from './components/gridSessionState';
import AppErrorBoundary from './components/AppErrorBoundary';
import AppProviders from './components/AppProviders';
import App from './App';

// Before anything else runs: a start-up that hangs leaves nothing else behind.
beginBootTrace();

// Registers the service worker (app shell + offline) and starts watching for a
// newer build; the profile menu is where it shows up when one lands.
startAppUpdates();

// Inside the Android app: the back key, and the shell's version.
void startNativeApp();

// Strg+Shift+F jumps into the quick search of the grid on screen.
installQuickSearchShortcut();

// A reload starts the lists unfiltered — before the first grid can read what
// this tab remembered (see gridSessionState).
clearGridSessionFiltersOnReload();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        {/* Outside everything, including the language and the theme: a crash in
            one of those would otherwise leave the boundary unable to render.
            See components/AppErrorBoundary. */}
        <AppErrorBoundary>
            <AppProviders>
                <CssBaseline />
                <App />
            </AppProviders>
        </AppErrorBoundary>
    </StrictMode>
);

// React has been handed the tree — anything that stalls from here on is inside
// the app, not in loading it.
markBoot('render');
